import Pet from '~models/pet'

export type AvatarSize = '24' | '32' | '40' | '48' | '64' | '72' | '96' | '128'
export type AvatarSizeCss = { [key in AvatarSize]: string }

export const AVATAR_SIZE_CSS: AvatarSizeCss = {
  '24': 'size-6',
  '32': 'size-8',
  '40': 'size-10',
  '48': 'size-12',
  '64': 'size-16',
  '72': 'size-[72px]',
  '96': 'size-24',
  '128': 'size-32',
}

export type AvatarProps = Readonly<{
  uri: string
  alt?: string
  size?: AvatarSize
  className?: string
}>

export type AvatarPetProps = Readonly<
  Omit<AvatarProps, 'uri'> & {
    pet?: Pet.ILevel1 | Pet.UpdateDraft
  }
>
